module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-be93d4.04ae1dcf.png";